import styled from 'styled-components'
import {
  BodyLarge,
  Heading2,
  BodyLightGray,
} from '@chegg-wt/core/theme/sunkist/typography'
import { Modal as ReactOverlayModal } from 'react-overlays'
import { adjust } from '@chegg-wt/core/theme/theme'
import { SpecialOutlineButton, SpecialButton } from '@chegg-wt/core/theme/fanta/button'

export const DefaultBackdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  background-color: ${({ theme }) => theme.Colors.forFonts.fColor06};
  opacity: 0.5;
`

export const Modal = styled(ReactOverlayModal)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3000;
`

export const PositioningWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`

export const smallFrameLayout = ({ theme }) => theme.breakpoints[1]

export const ModalContent = styled.div<{ fullMobileModal: boolean }>`
  position: relative;
  background-color: ${(props) => props.theme.colors.red};
  padding: ${(props) => props.theme.spacing.lg};
  background-color: ${(props) => props.theme.colors.white};
  margin: ${(props) => props.theme.spacing.sm};
  z-index: 3000;
  max-width: 600px;
  width: 100%;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  svg {
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor15};
    height: 30px;
    width: 30px;
  }
`

export const Header = styled.h2`
  ${Heading2};
  margin: 0;
`

export const CloseButton = styled.button`
  border: none;
  margin: 0;
  background-color: inherit;
`

export const Body = styled.div`
  ${BodyLarge};
  @media (max-width: ${(props) => adjust(smallFrameLayout(props), -1)}) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const DropdownText = styled.p`
  ${BodyLarge};
`

export const Buttons = styled.div`
  margin-top: 51px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  @media (min-width: ${(props) => smallFrameLayout(props)}) {
    justify-content: flex-end;
  }
`

export const ButtonContainer = styled(Buttons)``

export const CancelButton = styled(SpecialOutlineButton)`
  @media (min-width: ${(props) => smallFrameLayout(props)}) {
    margin-right: 18px;
  }
`

export const SubmitButton = styled(SpecialButton)`
  text-transform: capitalize;
`

export const Tabs = styled.div`
  ${BodyLightGray};
  display: flex;
  border-bottom: 2px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  margin-bottom: 44px;
`

export const Tab = styled.button<{ selected: boolean }>`
  margin-right: 30px;
  border: none;
  padding: 0;
  border-bottom: 6px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  text-transform: uppercase;
  background-color: inherit;
  ${({ selected, theme }) =>
    selected &&
    `
    border-bottom: 6px solid  ${theme.Colors.forInterface.interfaceColor01};
    color: ${theme.Colors.forInterface.interfaceColor17};
  `};
`
